import type { ExplorationVolume } from '../../types/exploration';
import { buildActivationOptions } from '../../lib/filters/buildCheckboxFilterOptions';
import FilterCheckboxDisclosure from './FilterCheckboxDisclosure';
import FilterCheckboxList from './FilterCheckboxList';

export default function ActivationStatusFilter({
  volumes,
  open,
  onOpenChange,
  pendingActivationStatuses,
  setPendingActivationStatuses,
}: {
  volumes: ExplorationVolume[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pendingActivationStatuses: string[];
  setPendingActivationStatuses: (statuses: string[]) => void;
}) {
  const options = buildActivationOptions(volumes);

  const handleChange = (optionId: string) => {
    if (pendingActivationStatuses.includes(optionId)) {
      setPendingActivationStatuses(pendingActivationStatuses.filter((s) => s !== optionId));
    } else {
      setPendingActivationStatuses([...pendingActivationStatuses, optionId]);
    }
  };

  if (!options.length) return null;

  return (
    <FilterCheckboxDisclosure
      title="Activation"
      open={open}
      onOpenChange={onOpenChange}
      selectedCount={pendingActivationStatuses.length}
      onClear={() => setPendingActivationStatuses([])}
    >
      <FilterCheckboxList
        options={options}
        isDisclosureOpen={open}
        isSelected={(key) => pendingActivationStatuses.includes(key)}
        onToggle={handleChange}
      />
    </FilterCheckboxDisclosure>
  );
}
